<template>
  <v-dialog :model-value="isShow" width="400" @keydown.esc="close">
    <v-card>
      <v-card-title class="text-h5"> Warning </v-card-title>
      <v-card-text>{{ notificationValue.dialogMessage }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" variant="text" @click="close"> ok </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts" src="./index.ts" />
<style lang="scss" src="./index.scss" scoped />
